import { initializeConnector } from "@web3-react/core";
import { WalletConnect } from "@web3-react/walletconnect-v2";

import { supportedChainsMap } from "../config";

const rpcDict = Object.keys(supportedChainsMap.evm)
  .map((key) => ({ chainId: key, rpcUrl: supportedChainsMap.evm[key].rpcUrl }))
  .reduce((prev, curr) => {
    prev[curr.chainId] = curr.rpcUrl;
    return prev;
  }, {});

export const [walletConnect, hooks] = initializeConnector<WalletConnect>(
  (actions) =>
    new WalletConnect({
      actions,
      options: {
        showQrModal: true,
        rpc: rpcDict,
        projectId: "a0f48fa1221281a35ac10b6988d1dfa2",
        chains: [1],
        optionalChains: Object.keys(supportedChainsMap.evm).map((id) =>
          parseInt(id),
        ),
      },
    }),
);
